// extracted by mini-css-extract-plugin
export default {"textarea":"Footer_textarea__V+IM5","submit":"Footer_submit__0vnHT","inputList":"Footer_inputList__cgaUd","picker":"Footer_picker__JtKDb"};